import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { errMsg } from "src/app/text_control/error-msg";
import { BTN } from "src/app/text_control/text_button";
import { _getStorage } from "src/app/utils/local-storage";

@Component({
  selector: "app-unlock-abb-detail",
  templateUrl: "./unlock-abb-detail.component.html",
  styleUrls: ["./unlock-abb-detail.component.scss"],
})
export class UnlockAbbDetailComponent implements OnInit {
  Active = 4;
  dataUnlock = [];
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";

  constructor(
    public router: Router,
    private alertController: AlertController,
    private apiService: ApiserviceService,
    public loadingController: LoadingController
  ) {
    this.dataUnlock = _getStorage(STORAGE.DATA_UNLOCK_ABB);

    if (!this.dataUnlock) {
      this.ErrorData("รูปแบบข้อมูลไม่ถูกต้อง");
    }
  }
  ionViewDidEnter() {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);

    if (this.userRole !== "ETAXSUPERADMIN" && this.userRole !== "SUPERADMIN") {
      this.router.navigate(["home"]);
      return;
    }
  }
  ngOnInit() {}

  async deleteUnlock(item) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class-confirm",
      header: "Confirm Unlock ABB!",
      message: `เลข Receipt No. / Tp No. / Barcode No. <br> เลขที่ <b>${item.abbno}</b>   หรือไม่? `,
      buttons: [
        {
          text: "ยกเลิก",
          role: "cancel",
          cssClass: "alertCancel",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
        {
          text: "ตกลง",
          cssClass: "alertloginOk",
          handler: async () => {
            try {
              const req = {
                storeBu: item.bu,
                storeLoc: item.loc,
                userId: window.localStorage.userID,
                id: item.id,
              };
              console.log("======= req confrim delete ======", req);
              this.apiService
                ._post(
                  this.apiService.apiUrl + this.apiService.confirmUnlock,
                  req
                )
                .then((res) => {
                  console.log("======= res confrim delete ======", res);
                  if (res.statusCode === 200) {
                    this.ErrorMsg(res.statusMessage);
                  } else {
                    this.ErrorMsg(res.statusMessage);
                  }
                });
            } catch (error) {
              // this.ErrorMsg(errMsg.error)
            }
          },
        },
      ],
    });

    await alert.present();
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
  async ErrorData(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
          handler: (blah) => {
            this.router.navigate(["backoffice/unlock-abb"]);
          },
        },
      ],
    });
    await alert.present();
  }

  backpage() {
    this.router.navigate(["backoffice/unlock-abb"]);
  }
}
